var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "risk-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9474 0H0V42.9474L42.9474 85.8947L85.8947 85.8947L85.8947 42.9474L42.9474 0Z",
    fill: "#9DA0A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "risk-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9474 64.1055H0V107.053L42.9474 150L85.8947 150L85.8947 107.053L42.9474 64.1055Z",
    fill: "#CDD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "risk-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.053 0H64.1055V42.9474L107.053 85.8947H150V42.9474L107.053 0Z",
    fill: "#777A7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "risk-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.053 64.1055H64.1055V107.053L107.053 150L150 150L150 107.053L107.053 64.1055Z",
    fill: "#414345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "risk-5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7896 85.7365H63.9475V85.105L64.1055 85.2629V85.2634L64.7368 85.8947H64.1055V107.053L85.8947 128.842V107.053L64.7368 85.8947L85.8947 85.8947L85.8947 64.7368L107.053 85.8947H128.842L107.053 64.1055H85.8947V64.7368L85.737 64.5791V64.5786L85.1054 63.9471H85.737V42.7892L63.9475 20.9997V42.7892L85.1054 63.9471H63.9475V85.105L42.7896 63.9471H21.0002L42.7896 85.7365Z",
    fill: "#131516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "risk-6",
    d: "M70 70 L75 75",
    stroke: "#403294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "risk-7",
    d: "M75 75 L0 0",
    stroke: "#403294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "risk-8",
    d: "M150 150 H75 V75 H150 Z",
    fill: "#998DD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.f67989de3a6f5467ff65f10ea401c0ed.svg";
export { ForwardRef as ReactComponent };